module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2560-0e460e5986b1e377152b5b1ae96bd07d.webp";